import type { ExpectedDebitsBand, ExpectedDebitsBandDraft } from "../types";

export type BandNumberField = Exclude<keyof ExpectedDebitsBandDraft, "relationClass">;

export interface BandField {
  key: BandNumberField;
  label: string;
  group: "age" | "male" | "female" | "composite";
}

/** Column order of the WebMUGs table and of pasted rows. */
export const BAND_FIELDS: readonly BandField[] = [
  { key: "ageStart", label: "Min Age", group: "age" },
  { key: "ageEnd", label: "Max Age", group: "age" },
  { key: "maleExpected", label: "Male Expected", group: "male" },
  { key: "maleBase", label: "Male Base", group: "male" },
  { key: "femaleExpected", label: "Female Expected", group: "female" },
  { key: "femaleBase", label: "Female Base", group: "female" },
  { key: "compositeExpected", label: "Composite Expected", group: "composite" },
  { key: "compositeBase", label: "Composite Base", group: "composite" },
];

export type BandComposite = Record<BandNumberField, number | null>;

/**
 * Composite line under a section: the simple average of each column across the
 * bands that have a value. The current table's composite is exposure-weighted;
 * that formula is still to be confirmed, so this is a placeholder roll-up.
 */
export function compositeOfBands(bands: readonly (ExpectedDebitsBandDraft | ExpectedDebitsBand)[]): BandComposite {
  const composite = {} as BandComposite;
  for (const field of BAND_FIELDS) {
    const values = bands.map((band) => band[field.key]).filter((value): value is number => typeof value === "number" && Number.isFinite(value));
    composite[field.key] = values.length === 0 ? null : values.reduce((sum, value) => sum + value, 0) / values.length;
  }
  return composite;
}
